export const MIN_CONVERSIONS_GOAL_TYPE = {
    MONTHLY: 'MONTHLY',
    LIFETIME: 'LIFETIME',
};
